export default {
  List: {
    Caption: "Định mức cấp phát tài sản",
    AddButton: "Thêm mới",
    SearchPlaceHolder: "Tìm kiếm nhà vị trí công việc...",
  },
  Detail: {
    AddTitle: "Thêm mới nhà cung cấp",
    EditTitle: "Sửa nhà cung cấp",
    DuplicateTitle: "Nhân bản nhà cung cấp",
    GeneralTabCaption: "Thông tin chung",
    ContactTabCaption: "Thông tin liên hệ",
    AccountObjectCode: "Mã nhà cung cấp",
    AccountObjectName: "Tên nhà cung cấp",
    AccountObjectGroupListName: "Nhóm nhà cung cấp",
    Address: "Địa chỉ",
    TaxCode: "Mã số thuế",
    Website: "Website",
    BankAccount: "TK ngân hàng",
    Tel: "ĐT cơ quan",
    BankName: "Mở tại",
    Email: "Email",
    Description: "Ghi chú",
    Prefix: "Xưng hô",
    ContactHomePhone: "ĐT nhà riêng",
    ContactName: "Họ và tên",
    ContactMobile: "ĐT di động",
    ContactTitle: "Chức danh",
    ContactTel: "ĐT cơ quan",
    ContactEmail: "Email",
    ContactAddress: "Địa chỉ",
    IdentificationNumber: "Số CMND/TCC",
    IssueDate: "Ngày cấp",
    IssueBy: "Nơi cấp",
  },
};
